import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Vuex from 'vuex';
import Ajax from '../../lib/ajax'
Vue.use(Vuex);
import CustomerStatementReportItem from '@/store/entities/customerStatementReportItem';
import appconst from '../../lib/appconst';
interface CustomerStatementReportState  extends ListState<CustomerStatementReportItem> {
}
class CustomerStatementReportModule   extends ListModule<CustomerStatementReportState, any, CustomerStatementReportItem>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<CustomerStatementReportItem>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<CustomerStatementReportState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Inventory/CustomerStatementReport', { params: payload.data });
            context.state.loading = false;
            context.state.list = reponse.data.result.items as CustomerStatementReportItem[];
            context.state.totalCount =  reponse.data.result.totalCount;
        },
        async exportCustomerStatement(context:ActionContext<CustomerStatementReportState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}report/exportCustomerStatementReport${abp.utils.buildQueryString(Object.keys(payload.data).map((key) => {
                return {
                    name: key,
                    value: payload.data[key]
                }
            }), true)}`, "_blank");   
        },
        
    };
    mutations = {
        setCurrentPage(state: CustomerStatementReportState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: CustomerStatementReportState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const reportModule = new CustomerStatementReportModule();
export default reportModule;